/* ==========================================================================
   Enova - Event content
   Smooth parallax for the gallery collage.
   ========================================================================== */

(function () {
  if (typeof window === 'undefined') return;

  var reduceMotionMQ = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false, addEventListener: function () {} };

  var isMobileMQ = window.matchMedia
    ? window.matchMedia('(max-width: 749px)')
    : { matches: false, addEventListener: function () {} };

  var items = [];
  var rafId = null;
  var initialized = false;

  function collectItems() {
    var mobileScale = isMobileMQ.matches ? 0.55 : 1;
    var nodes = document.querySelectorAll(
      '.enova-event-content__gallery-item[data-parallax-speed]'
    );

    items = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var speed = parseFloat(el.getAttribute('data-parallax-speed')) || 0;
      items.push({
        el: el,
        speed: speed * mobileScale,
        current: 0,
        target: 0,
      });
    }
  }

  function schedule() {
    if (rafId !== null) return;
    rafId = window.requestAnimationFrame(tick);
  }

  function tick() {
    rafId = null;

    if (reduceMotionMQ.matches) {
      for (var i = 0; i < items.length; i++) {
        items[i].el.style.transform = '';
      }
      return;
    }

    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vhHalf = vh * 0.5;
    var needMore = false;

    for (var j = 0; j < items.length; j++) {
      var item = items[j];
      var rect = item.el.getBoundingClientRect();

      if (rect.bottom < -vh || rect.top > vh * 2) {
        continue;
      }

      var center = rect.top + rect.height * 0.5;
      var delta = center - vhHalf;
      item.target = -delta * item.speed;

      var diff = item.target - item.current;
      if (Math.abs(diff) > 0.08) {
        item.current += diff * 0.1;
        needMore = true;
      } else {
        item.current = item.target;
      }

      item.el.style.transform =
        'translate3d(0,' + item.current.toFixed(2) + 'px,0)';
    }

    if (needMore) schedule();
  }

  function onScroll() {
    schedule();
  }

  function onResize() {
    collectItems();
    schedule();
  }

  function init() {
    if (initialized) return;
    initialized = true;

    collectItems();
    if (!items.length) return;

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    if (reduceMotionMQ.addEventListener) {
      reduceMotionMQ.addEventListener('change', schedule);
    }
    if (isMobileMQ.addEventListener) {
      isMobileMQ.addEventListener('change', onResize);
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        if (
          event.target &&
          event.target.classList &&
          event.target.classList.contains('enova-event-content-section')
        ) {
          collectItems();
          schedule();
        }
      }
    );

    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
